import { JSXElement } from '@/common/types';
import { RouterProvider, createBrowserRouter } from 'react-router';
import { routes } from './routes';

const router = createBrowserRouter(routes);

export function Router(): JSXElement {
    return <RouterProvider router={router} />;
}
